import React from 'react';
import { Settings } from 'lucide-react';

const NetworkFormFields = ({ formik, trackingMethods }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-6">
      <div className="flex items-center gap-2 mb-4">
        <Settings className="h-5 w-5 text-primary" />
        <h2 className="text-lg font-semibold">Configurações da Rede</h2>
      </div>
      
      <form id="networkForm" onSubmit={formik.handleSubmit} className="space-y-4">
        {/* Nome */}
        <div>
          <label htmlFor="name" className="block text-sm font-medium mb-1">
            Nome da Rede *
          </label>
          <input
            id="name"
            name="name"
            type="text"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`w-full rounded-md border px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
              formik.touched.name && formik.errors.name ? 'border-red-500' : 'border-input'
            }`}
            placeholder="Ex: Lomadee, Amazon Associates..."
          />
          {formik.touched.name && formik.errors.name && (
            <p className="text-sm text-red-500 mt-1">{formik.errors.name}</p>
          )}
        </div>

        {/* Método de Rastreamento */}
        <div>
          <label htmlFor="tracking_method" className="block text-sm font-medium mb-1">
            Método de Rastreamento *
          </label>
          <select
            id="tracking_method"
            name="tracking_method"
            value={formik.values.tracking_method}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`w-full rounded-md border px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
              formik.touched.tracking_method && formik.errors.tracking_method ? 'border-red-500' : 'border-input'
            }`}
          >
            <option value="">Selecione um método</option>
            {trackingMethods.map((method) => (
              <option key={method.value} value={method.value}>
                {method.label}
              </option>
            ))}
          </select>
          {formik.touched.tracking_method && formik.errors.tracking_method && (
            <p className="text-sm text-red-500 mt-1">{formik.errors.tracking_method}</p>
          )}
        </div>

        {/* Template */}
        <div>
          <label htmlFor="template" className="block text-sm font-medium mb-1">
            Template {formik.values.tracking_method === 'template_builder' && '*'}
          </label>
          <textarea
            id="template"
            name="template"
            value={formik.values.template}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={formik.values.tracking_method !== 'template_builder'}
            rows={3}
            className={`w-full rounded-md border px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
              formik.touched.template && formik.errors.template ? 'border-red-500' : 'border-input'
            } ${formik.values.tracking_method !== 'template_builder' ? 'bg-gray-50' : ''}`}
            placeholder="Ex: https://example.com/redirect?url={url}&ref={ref}"
          />
          {formik.touched.template && formik.errors.template && (
            <p className="text-sm text-red-500 mt-1">{formik.errors.template}</p>
          )}
        </div>

        {/* Parâmetros */}
        <div>
          <label htmlFor="params" className="block text-sm font-medium mb-1">
            Parâmetros (JSON)
          </label>
          <textarea
            id="params"
            name="params"
            value={JSON.stringify(formik.values.params, null, 2)}
            onChange={(e) => {
              try {
                const parsed = JSON.parse(e.target.value);
                formik.setFieldValue('params', parsed);
              } catch (error) {
                // Ignore JSON parse errors while typing
              }
            }}
            rows={4}
            className="w-full rounded-md border border-input px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring font-mono"
            placeholder='{"ref": "12345", "campaign": "summer"}'
          />
        </div>
      </form>
    </div>
  );
};

export default NetworkFormFields;